// extracted by mini-css-extract-plugin
module.exports = {"container":"LeftSidebar-module--container--1aI9n"};